import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articlesView_template_new} from "../components/templates/articlesView_template_new";
import {articleAnalytics_template} from "../components/templates/articleAnalytics_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

let chartDiv;

export class articles_view_new extends vnModule_knockoutJS{

    protected articlesView: articlesView_template_new;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[];
    protected articleAnalytics : articleAnalytics_template;
    protected SensaiXHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "articles_view_new";
    }

    buildContent(): Array<Element>{

        this.articlesView = new articlesView_template_new("view_template", this.viewModel, this);
        this.articlesView.setBrandId(this.getVnAppZone().app.params.idBrand)
        return [this.articlesView.build()];
    }

    public fillPage(): void{

        this.maximizeSideNav();
        this.getArticleReferences();

    }

    protected maximizeSideNav(){
        document.getElementsByClassName('btn-sidebar')[0].classList.remove("is-closed");
        document.getElementsByClassName('sidenav')[0].classList.remove("is-closed");
        document.getElementsByClassName('sidenav')[0].classList.remove("is-desable");
        document.getElementsByClassName('main-header')[0].classList.remove("is-desable");
        document.getElementById('closedHeader').classList.remove("is-closed");
        document.getElementById('header').classList.remove("is-closed");
        document.getElementById('closedContent').classList.remove("is-closed");
    }

    protected getArticleReferences(){

        // LOADING : starts
        this.loadingIn(this.articlesView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    protected getArticleAnalytics() {

        if (this.XHRHdls['getArticleAnalytics']) {

            this.XHRHdls['getArticleAnalytics'].cancelAndReset();
        }
        if(this.articlesView.getTopKeyWordAnalytics() ==null || this.articlesView.getTopKeyWordAnalytics().length <1 ){

            this.loadingIn(this.articlesView.builtTemplate);

            let idBrand = this.getVnAppZone().getApp().params.idBrand;
            let idArticle = this.getVnAppZone().getApp().params.id;
            let usrReq_url: string = '/api/brand/' + idBrand + "/articles/topKeywordAnalytics/get/" + idArticle;
            let usrReq_params: Array<Array<string>> = [];

            this.XHRHdls['getArticleAnalytics'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdls['getArticleAnalytics'].onReadyStateFunction = this.onGetKeywordAnalyticsReturn;
            this.XHRHdls['getArticleAnalytics'].execute();
        }
    }

    protected onGetKeywordAnalyticsReturn(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesView.setTopKeyWordAnalytics(responseParsed);
            });
            obj.loadingOut(obj.articlesView.builtTemplate);
        }
    }

    protected onReferenceRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesView.setPermissions(responseParsed.permissions);
                obj.articlesView.setArticlePagesSettings(responseParsed.articlePagesSettings);
                obj.articlesView.setSegments(responseParsed.segments)
                let vnApp = obj.getVnAppZone().app;
                obj.articlesView.setIdLoggedUser(vnApp.loggedUser.user.id);
                //obj.articlesView.setAuthorPrompts(responseParsed.authorAgreements);
                obj.getArticleData();

            });

        }
    }

    protected getShortTermReport() {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        chartDiv = document.getElementById("shortTermReportChart");
        if(chartDiv){
            this.loadingIn(chartDiv);
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idArticle = this.getVnAppZone().getApp().params.id;

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/shortTermReport/get/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.articlesView.getArticleAnalytics().getTemplateViewModel().shortTermReportRange()]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetShortTermReportReturn;
        this.XHRHdl.execute();
    }

    protected onGetShortTermReportReturn(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response,function (key, value) {
                    if (key == "date" || key == "publishDate" || key == "republishDate") {
                        return new Date(value);
                    } else {
                        return value;
                    }
                });
                obj.articlesView.setShortTermReport(responseParsed);
            });
            if(obj.getChartDiv()){

                obj.loadingOut(obj.getChartDiv());
            }
        }
    }

    public getChartDiv(){
        return chartDiv;
    }

    protected getArticleData(){

        // LOADING : starts
        this.loadingIn(this.articlesView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/get/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                //PME-3186 permalink and redirects in view
                obj.articlesView.setPermalinkHistory(responseParsed.data.permalinkHistory);
                obj.articlesView.setPermalinkRedirect(responseParsed.data.permalinkRedirects);
                obj.setArticleData(responseParsed.data.article);
                obj.setDirectoryData(responseParsed.data.directory);
                obj.setDisplayAuthors(responseParsed.data.displayAuthors);
                obj.setPinnedTags(responseParsed.data.article);
                obj.setPlagiarismResults(responseParsed.data.plagiarismResults);
            });

            obj.loadingOut(obj.articlesView.builtTemplate);
        }
    }

    public setArticleData(article_data): void{

        this.articlesView.setId(article_data['id']);
        this.articlesView.setBrand(article_data['brand']);
        this.articlesView.directoryView.setBrand(article_data['brand']);
        this.articlesView.setIdTemplate(article_data['template']['id']);
        this.articlesView.setTemplateLayout(article_data['templateLayout'] ? article_data['templateLayout']['name'] : null);
        this.articlesView.setTitle(article_data['title']);
        this.articlesView.setReference(article_data['reference']);
        this.articlesView.setIsEditShown(true);
        this.articlesView.setExcerpt(article_data['excerpt'] || 'None');
        this.articlesView.setIsTableOfContents(article_data['tableOfContents']);
        this.articlesView.setIsSponsored(article_data['isSponsored']);
        this.articlesView.setFileUrl(article_data['pdf'] ? article_data['pdf'] : 'None');
        this.articlesView.setCategories(article_data['categories'] ? article_data['categories'] : [{name:'None'}]);
        this.articlesView.setTags(article_data['tags'] ? article_data['tags'] : [{name:'None'}]);
        this.articlesView.setSeoTitle(article_data['seoMetaTitle'] || 'None');
        this.articlesView.setSeoDescription(article_data['seoMetaDescription'] || 'None');
        this.articlesView.setSmoTitle(article_data['socialMediaTitle'] || 'None');
        this.articlesView.setSmoDescription(article_data['socialMediaExcerpt'] || 'None');
        this.articlesView.setSocialTagLine(article_data['socialTagLine'] || 'None');
        this.articlesView.setDateCreated(article_data['dateCreated']);
        this.articlesView.setDateUpdated(article_data['dateUpdated']);
        this.articlesView.setTemplate(article_data['template'] ? article_data['template']['name'] : "");
        this.articlesView.setStatus(article_data['status']['name']);
        this.articlesView.setDateStatus(article_data['dateLastStatus']);
        this.articlesView.setPublishStatus(article_data['publishStatus']['name']);
        this.articlesView.setIdPublishStatus(article_data['publishStatus']['id'])
        this.articlesView.setDatePublishStatus(article_data['dateLastPublishStatus']);
        this.articlesView.setLastSync(article_data['syncStatus']['name']);
        this.articlesView.setDateLastSync(article_data['dateLastSyncStatus']);
        this.articlesView.setDatePublished(article_data['dateOriginalPublish'])
        this.articlesView.setDateMostRecentPublishStatus(article_data['dateMostRecentPublishedStatus'] ? article_data['dateMostRecentPublishedStatus'].date.substring(0,19) : '');
        this.articlesView.setArticleRepublishData(article_data['republishes']);
        this.articlesView.setPermalink(article_data['permalink']);
        this.articlesView.setReviewItems(article_data['reviewItems']);
        this.articlesView.setFeaturedTag(article_data['pinnedTag'])
        this.articlesView.setPrimaryCategory(article_data['primaryCategory'] ? article_data['primaryCategory']['name'] : 'None');
        this.articlesView.setPrimaryTag(article_data['primaryTag']);
        this.articlesView.setReviewTag(article_data['reviewTag']);

        // Ensure Article View Pages Open External Links in New Tabs
        let regx = /href=/g;
        let new_article_content = article_data['content'].replace(regx, 'target=\"_blank\" href=');
        this.articlesView.setContent(new_article_content);
        this.articlesView.setAdditionalCredit(article_data['additionalCredit'] || 'None');
        let new_article_introText = article_data['introText'].replace(regx, 'target=\"_blank\" href=');
        this.articlesView.setIntroText(new_article_introText);
        article_data['faq'].forEach(item=>{
           if(item['answer']){
               let new_answer = item['answer'].replace(regx, 'target=\"_blank\" href=');
               item['answer'] = new_answer;
           }
        });
        this.articlesView.setFaqs(article_data['faq']);

        if(article_data['poll']){

            this.articlesView.setDisplayPoll(article_data['poll']['name']);
        }


        if(article_data['featuredImage']){
            this.articlesView.setFeaturedImageUrl(article_data['featuredImage']['url']);
        }

        if(article_data['thumbnail']){
            this.articlesView.setThumbnailImageUrl(article_data['thumbnail']['url']);
        }

        if(article_data['alternateImage']){
            this.articlesView.setAlternateImage(article_data['alternateImage']['url']);
        }

        if(article_data['pinnedArticle']){
            this.articlesView.setNextArticle(article_data['pinnedArticle']['title']);
        }

        if(article_data['editor']){
            this.articlesView.setEditor(article_data['editor']['valnet_user']['fullName']);
        }

        if(article_data['author']){
            this.articlesView.setAuthor(article_data['author']['valnet_user']['fullName']);
        }

        if(article_data['juniorEditor']){
            this.articlesView.setJrEditor(article_data['juniorEditor']['valnet_user']['fullName']);
        }

        if(article_data['ideator']){
            this.articlesView.setIdeator(article_data['ideator']['valnet_user']['fullName']);
        }

        if(article_data['targetAudience']){
            this.articlesView.setTargetAudience(article_data['targetAudience']['name'] );
        }

        if ( article_data['directoryItems']) {
            // Ensure Article View Pages Open External Links in New Tabs
            article_data['directoryItems'].forEach(directory=>{
                if(directory['description']){
                    let new_directory_description = directory['description'].replace(regx, 'target=\"_blank\" href=');
                    directory['description'] = new_directory_description;
                }
            });

            this.articlesView.directoryView.setDirectoryItems( article_data['directoryItems'] );
        }

        if(article_data['intent']){
            this.articlesView.setIntent(article_data['intent']['name']);
        }

        if(article_data['contentType']){
            this.articlesView.setIdContentType(article_data['contentType']['id']);
            this.articlesView.setContentType(article_data['contentType']['name']);
        }

        this.articlesView.setArticleHistoricalReviewComments(article_data['reviewComments']);

        if(article_data['segment']){
            this.articlesView.setSegment(article_data['segment']['name']);
        }

        if(article_data['networkCategory']){
            this.articlesView.setNetworkCategory( article_data['networkCategory']['name'] );
        }

        if(article_data['postPaymentCategory']) {
            this.articlesView.setPostPaymentCategory(article_data['postPaymentCategory']['name']);
        }

        if(article_data['isHiddenFromAllSite']) {
            this.articlesView.setDisplayConfiguration("Hide From Website");
        }else if (article_data['isHiddenFromTrending'] && article_data['isHiddenFromHomePage']) {
            this.articlesView.setDisplayConfiguration("Hide From Homepage and Trending");
        }else if(article_data['isHiddenFromHomePage']){
            this.articlesView.setDisplayConfiguration("Hide From Homepage");
        }else if (article_data['isHiddenFromTrending']) {
            this.articlesView.setDisplayConfiguration("Hide From Trending");
        }

        this.articlesView.setIsAdHidden(article_data['isAdHidden'] ? true: false);
        this.articlesView.setIsAmpDisabled(!article_data['isAmpEnabled']);
        this.articlesView.setIsUnderEmbargo(article_data['isUnderEmbargo']);

        this.articlesView.setIsDevelopingStory(article_data['isDevelopingStory']);
        this.articlesView.setListOrder(article_data['listOrder']);

        if(article_data['classification']){
            this.articlesView.setClassification(article_data['classification']['name']);
        }

        this.articlesView.setIsFeaturedImageHidden(article_data['isFeaturedImageHidden'] ? article_data['isFeaturedImageHidden']: false);
        this.articlesView.setIsCommentsDisabled(article_data['isCommentsDisabled'] ? article_data['isCommentsDisabled']: false);
        this.articlesView.setIsReadNextDisabled(article_data['isReadNextDisabled'] ? article_data['isReadNextDisabled']: false);
        this.articlesView.setIsDisplayCardQuickLinksShown(article_data['isDisplayCardQuickLinksShown'] ? article_data['isDisplayCardQuickLinksShown']: false);
        this.articlesView.setIsSidebarHidden(article_data['isSidebarHidden'] ? article_data['isSidebarHidden']: false);
        this.articlesView.setIsDisplayCardQuickLinksMobileShown(article_data['isDisplayCardQuickLinksMobileShown'] ? article_data['isDisplayCardQuickLinksMobileShown']: false);
        this.articlesView.setPlagiarismStatus(article_data['plagiarismStatus']);
        this.articlesView.setIsFeaturedImageMobileOptimized(article_data['isFeaturedImageOptimized'])

        if(article_data['featuredVideo']){
            const featuredVideo = article_data['featuredVideo']
            this.articlesView.setFeaturedVideo(featuredVideo)
        }

        if(article_data["channel"]) {
            this.articlesView.setChannel(article_data["channel"]);
            if(article_data["playlists"]) {
                this.articlesView.setPlaylists(article_data["playlists"]);
            }
        }

        if(article_data['republishesCount']){
            this.articlesView.setRepublishesCount(article_data['republishesCount']);
        }
    }

    public setPlagiarismResults(plagiarismResults){
        this.articlesView.setPlagiarismResults(plagiarismResults ? plagiarismResults : []);
    }

    public setDirectoryData(directory_data): void{

        let title = (directory_data) ? directory_data['title'] : 'None'
        this.articlesView.setIncludeInDirectory(title);
    }

    public setDisplayAuthors(displayAuthors): void{

        this.articlesView.setDisplayAuthors(displayAuthors);
    }

    public setPinnedTags(article_data){

        this.articlesView.setPinnedTagTitle(article_data.pinnedTagsTitle || 'None');
        this.articlesView.setPinnedTagPosition(article_data.pinnedTagsPosition || 'None');
        this.articlesView.setPinnedTagStyle(article_data.pinnedTagsStyle || 'None');

        if(article_data.pinnedTagType) {

            let tagName: string = `${article_data.pinnedTagType.name} ${article_data.pinnedTagType.formattedDataset}`;
            this.articlesView.setPinnedTagTagType(tagName);
            let option = article_data.pinnedTagType.fields.filter(v => v.dataType != "tags" && v.id == article_data.pinnedTagsSpecs[0])
            this.articlesView.setPinnedTagTypeOption(option[0].label);
        }

        if(article_data.pinnedTags){

            let tags = [];

            article_data.pinnedTags.forEach(tag =>{
                tags.push(tag.tag);
            })

            this.articlesView.setPinnedTags(tags);
        }

        this.articlesView.setIsSubContent(!!article_data['isSubContent'])

    }

    protected editArticle(id){

        let fullEmakiBrands = ["22", "21", "13", "4", "9", "14", "20", "11", "1", "23", "24", "26", "5", "7", "6", "27", "28", "29", "30", "31", "32", "33", "36", "40","41", "42", "2","43", "44", "48", "49"];

        if( fullEmakiBrands.indexOf(this.getVnAppZone().app.params.idBrand) > -1){
            page('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/edit/' + id)
        }else{

            page('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/edit-old/' + id)
        }

    }

    protected goBackToArticles(){

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/');
        }
    }

    protected previewArticle(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        let formReq_params: Array<Array<string>> = [];
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        if(brandDomain.includes("topspeed.com") && !brandDomain.includes("ads.topspeed.com")){
            brandDomain = brandDomain.replace("topspeed.com","ads.topspeed.com");
        }

        //let jsonParsed = JSON.parse(article);
        //let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + article.id + '/';
        let url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/article/previewNoSave/'+this.articlesView.getId()+'/';

        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }
        formReq_params.push(["data", "None"]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(url,formReq_params, this);
        //using post to avoid data size limitation of GET
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPreviewReturn;
        XHRHdl.execute();
    }

    protected onPreviewReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.openArticlePreview(responseParsed, false);
            });

            obj.loadingOut(obj.articlesView.builtTemplate);
        }
    }

    protected openArticlePreview(data, isAmp = false) {
        let origin = document.location.origin;
        let brandDomain = data.data.brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }

        let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + data.data.emakiPreview.id + '/';

        if(url.includes("mig1")){
            url = url.replace("mig1", "qa4");
        }

        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa3");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }

        if (isAmp){

            url = url + 'amp/';
        }

        var f = document.createElement('form');
        f.action = url;
        f.method = 'POST';
        f.target = '_blank';

        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'token';
        i.value = 'PWjvmuQqaq`;33}4';
        f.appendChild(i);

        var c = document.createElement('input');
        c.type = 'hidden';
        c.name = 'content';
        //c.value = this.articlesView.getContentTypeToPreview();
        f.appendChild(c);

        //if an emakiPreview was created, then add it so the brand site can read it. Otherwise add nothing so the brand site can read from DB instead.
        if (data.data.emakiPreview){

            var c = document.createElement('input');
            c.type = 'hidden';
            c.name = 'article';
            c.value = JSON.stringify(data.data.emakiPreview);
            f.appendChild(c);
        }

        document.body.appendChild(f);
        f.submit();
        document.body.removeChild(f);
    }

    protected viewArticleOnSite(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + article.permalink();

        if(url.includes("mig1")){
            url = url.replace("mig1", "qa4");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa3");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }
        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        let element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected previewArticleAMP(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + article.id() + '/amp';

        var f = document.createElement('form');
        f.action=url;
        f.method='POST';
        f.target='_blank';

        var i=document.createElement('input');
        i.type='hidden';
        i.name='token';
        i.value='PWjvmuQqaq`;33}4';
        f.appendChild(i);

        document.body.appendChild(f);
        f.submit();
        document.body.removeChild(f);
    }

    protected viewArticleOnSiteAMP(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + article.permalink() + "amp";

        let element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected editWatchlist(isAddToWatchlist) {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/editWatchlist/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", isAddToWatchlist]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetAddedToWatchlist;
        this.XHRHdl.execute();
    }

    protected onGetAddedToWatchlist(req, obj) {
        return () => {
            if(req.request.status == 200){

                obj.manageResponse(req, obj, () => {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.articlesView.setIsOnWatchlist(responseParsed);
                    if(responseParsed){
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Added to watchlist');
                    }else{
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Removed from watchlist');
                    }
                    obj.getVnAppZone().showNotificationToModule();
                });
            }else{

                let responseParsed = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.message);
                obj.getVnAppZone().showNotificationToModule();
            }

            obj.articlesView.setWatchlistButtonEnabled(true);
        }
    }

    public getSensaiResults(target, idContentType) {

        if (this.SensaiXHRHdl) {
            this.SensaiXHRHdl.cancelAndReset();
        }

        this.articlesView.showFeedbackTabLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/sensai/get-results/';
        let formReq_params: Array<Array<string>> = [];

        let idArticle = this.articlesView.getId();
        formReq_params.push(["idArticle", idArticle]);
        formReq_params.push(["idContentType", this.articlesView.getIdContentType()]);

        this.SensaiXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiResultsReturn;
        this.SensaiXHRHdl.execute();
    }

    public onGetSensaiResultsReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let guidelines = obj.organizeSensaiResults(responseParsed);
                obj.articlesView.articleReviewHistory.setGuidelines(guidelines);

                obj.articlesView.hideFeedbackTabLoading();
            });
        }
    }

    public organizeSensaiResults(responseParsed) {
        return Object.keys(responseParsed.feedback).map(function (section) {
            return {
                sectionName: section,
                rules: Object.keys(responseParsed.feedback[section]).map(function (rule) {
                    return {
                        ruleName: rule,
                        ruleStatus: responseParsed.feedback[section][rule]["ruleStatus"],
                        isMandatory: responseParsed.feedback[section][rule]["isMandatory"]
                    };
                })
            };
        });
    }

    public getSensaiArticleReferences(target, idArticle) {
        if (this.SensaiXHRHdl) {
            this.SensaiXHRHdl.cancelAndReset();
        }

        this.articlesView.showFeedbackTabLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/sensai/references/' + idArticle + '/';
        let formReq_params: Array<Array<string>> = [];

        this.SensaiXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiArticleReferences;
        this.SensaiXHRHdl.execute();
    }

    public onGetSensaiArticleReferences(req,obj){
        return () => {

            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesView.setSavedFeedbacksHistoryOptions(responseParsed);
            });
        }
    }

    public filterFeedBackHistory(idArticle, uuid) {

        if (this.SensaiXHRHdl) {
            this.SensaiXHRHdl.cancelAndReset();
        }

        this.articlesView.showFeedbackTabLoading();

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/sensai/feedback/' + idArticle + '/';
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = {uuid: uuid}
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.SensaiXHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.SensaiXHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.SensaiXHRHdl.onReadyStateFunction = this.onGetSensaiArticleFeedbackHistory;
        this.SensaiXHRHdl.execute();
    }

    public onGetSensaiArticleFeedbackHistory(req,obj){
        return ()=> {

            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response);

                let guidelines = obj.organizeSensaiResults(responseParsed);
                obj.articlesView.articleReviewHistory.setGuidelines(guidelines);

                obj.articlesView.hideFeedbackTabLoading();
            });
        }
    }

    public filterDropdownOnChange(idElement) {

        switch (idElement) {

            case "savedRulesHistory":
                let id = this.articlesView.getTemplateViewModel().id();
                let uuid = this.articlesView.getFeedbackHistoryOption();
                if (id && uuid != 0) {
                    this.filterFeedBackHistory(id, uuid);
                } else {
                    let idContentType = this.articlesView.getTemplateViewModel().idContentType();
                    this.getSensaiResults("article_content", idContentType);
                }
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/articles_view_new.ts